import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { GetCountry } from "../../../../redux/master/action";
import { disabledStyle } from "../../../Common/ClickDisable";
import ReactSelect from "react-select";
import { Tooltip } from "react-tooltip";
import { useDispatch } from "react-redux";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const bxpDatatomap = [
  { title: (<>Rental type <AsteriskLabel /></>), name: "rental", placeholder: "Rental Type" },
  { title: "Price in SAR", name: "price", placeholder: "Enter Price in SAR" },
  {
    title: "Price interpreter in SAR",
    name: "price_interpreter",
    placeholder: "Enter Price in SAR",
  },
];

const duretiontypeoptions = [
  { value: 1, label: "Hour" },
  { value: 2, label: "Days" },
  { value: 3, label: "Week" },
  { value: 4, label: "Month" },
];

const WorkSamples = ({ bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetCountry());
  }, [dispatch]);

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FirstTimeUsers.module.scss");
  }, []);

  const initialValues = {
    rental_only: bxpData?.rental_only == 0 ? 0 : 1,
    price: bxpData?.price || "",
    price_type: bxpData?.price_type || "",
    price_interpreter: bxpData?.price_interpreter || "",
    rental_with_interpreter: bxpData?.rental_with_interpreter || 0,
    price_type_interpreter: bxpData?.price_type_interpreter || "",
    atLeastOneSelected: "",
  };

  const validationSchema = Yup.object().shape({
    rental_only: Yup.number().required("Please select a rental option."),
    rental_with_interpreter: Yup.number().required(
      "Please select a rental option with interpreter."
    ),

    atLeastOneSelected: Yup.boolean().test(
      "at-least-one",
      "Please select either 'Rental Only' or 'Rental with Interpreter'.",
      function () {
        const { rental_only, rental_with_interpreter } = this.parent;
        return rental_only == 1 || rental_with_interpreter == 1;
      }
    ),

    price: Yup.string().when("rental_only", {
      is: 1,
      then: (schema) =>
        schema
          .required("Price is required")
          .test(
            "price-required",
            "Minimum value should be 1",
            (value) => value && value !== "0"
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

    price_type: Yup.string().when("rental_only", {
      is: 1,
      then: (schema) =>
        schema
          .required("Price per is required")
          .test(
            "price-type-required",
            "Price per is required",
            (value) => value && value.trim().length > 0
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

    price_interpreter: Yup.string().when("rental_with_interpreter", {
      is: 1,
      then: (schema) =>
        schema
          .required("Price with interpreter is required")
          .test(
            "price-interpreter-required",
            "Minimum value should be 1",
            (value) => value && value !== "0"
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

    price_type_interpreter: Yup.string().when("rental_with_interpreter", {
      is: 1,
      then: (schema) =>
        schema
          .required("Price type for Interpreter is required")
          .test(
            "price-type-interpreter-required",
            "Price type is required",
            (value) => value && value.trim().length > 0
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };
    try {
      updatedData = { ...updatedData };
      setbxpData(updatedData);
      setActiveTab("PricingTerms");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                if (prop.name == "rental") {
                  return (
                    <div key={key} className="form-group">
                      <label>
                        {prop.title}{" "}
                        <img
                          data-tooltip-id="my-tooltip-1"
                          src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                          alt=""
                        />
                      </label>
                      <div className="label-check">
                        <label className=" rental-box">
                          <Field
                            type="checkbox"
                            name="rental_only"
                            value="1"
                            checked={formik.values["rental_only"] == 1}
                            onChange={(e) =>
                              formik.setFieldValue(
                                "rental_only",
                                e.target.checked ? 1 : 0
                              )
                            }
                          />
                          <span class="checkmark1"></span>
                          Rental only
                        </label>
                        <label className=" rental-box">
                          <Field
                            type="checkbox"
                            name="rental_with_interpreter"
                            value="1"
                            checked={
                              formik.values["rental_with_interpreter"] == 1
                            }
                            onChange={(e) =>
                              formik.setFieldValue(
                                "rental_with_interpreter",
                                e.target.checked ? 1 : 0
                              )
                            }
                          />
                          <span class="checkmark1"></span>
                          Rental with interpreter
                        </label>
                      </div>
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }

                if (prop.name == "price") {
                  if (formik.values?.rental_only == 1 && formik?.values?.rental_only == 1) {
                    return (
                      <>
                        <h6 className="rental-price">Price for rental only</h6>
                        <div className="row">
                          <div className=" col-md-8">
                            <NumberInputBox
                              type="number"
                              id={prop.name}
                              title={prop.title}
                              name={prop.name}
                              placeholder={prop.placeholder}
                              key={key}
                            />
                          </div>
                          <div className=" col-md-4 form-group mb-0">
                            <label>Price per <AsteriskLabel /></label>
                            <ReactSelect
                              options={duretiontypeoptions}
                              placeholder="Select "
                              value={duretiontypeoptions.find(
                                (val) =>
                                  val.value == formik.values["price_type"]
                              )}
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "price_type",
                                  selectedOption?.value
                                )
                              }
                            />
                            <ErrorMessage
                              name="price_type"
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                      </>
                    );
                  }
                  return null;
                }

                if (prop.name == "price_interpreter") {
                  if (formik?.values?.rental_with_interpreter == 1) {
                    return (
                      <>
                        <h6 className="rental-price">
                          Price for Rental with Interpreter
                        </h6>
                        <div className="row">
                          <div className="form-group col-md-8">
                            <NumberInputBox
                              title={prop.title}
                              name={prop.name}
                              placeholder={prop.placeholder}
                              key={key}
                            />
                          </div>
                          <div className="form-group col-md-4">
                            <label>Price per <AsteriskLabel /></label>
                            <ReactSelect
                              options={duretiontypeoptions}
                              placeholder="Select "
                              value={duretiontypeoptions.find(
                                (val) =>
                                  val.value ==
                                  formik.values["price_type_interpreter"]
                              )}
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "price_type_interpreter",
                                  selectedOption?.value
                                )
                              }
                            />
                            <ErrorMessage
                              name="price_type_interpreter"
                              component="div"
                              className="error"
                            />
                          </div>
                        </div>
                      </>
                    );
                  }
                  return null;
                }

                return (
                  <FieldInput
                    title={prop.title}
                    name={prop.name}
                    placeholder={prop.placeholder}
                    key={key}
                  />
                );
              })}

              <ErrorMessage
                name="atLeastOneSelected"
                component="div"
                className="error"
              />

              <div className="button-container">
                <div
                  style={loading ? disabledStyle : {}}
                  type="button"
                  className="prev-button btn w-100"
                  onClick={() => setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <div
                  className="next-button btn w-100"
                  type="submit"
                  onClick={formik.handleSubmit}
                >
                  {loading ? <LoginLoaderButton /> : "Next"}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content="The owner will provide an expert to interpret the information provided by you and will operate the machine on your behalf."
      />
    </div>
  );
};

export default WorkSamples;